import { configureStore } from '@reduxjs/toolkit';
import tourDraftReducer from '@store/slices/tourDraftSlice';
import modeToolDraftReducer from '@store/slices/modeToolDraftSlice';
import directiosApiRoutePointReducer from '@store/slices/directiosApiRoutePointSlice';
import directiosApiRoutePointRawReducer from '@store/slices/directiosApiRoutePointRawSlice';

// Root redux store for all CMS draft/edit flows.
const store = configureStore({
  reducer: {
    tourDraft: tourDraftReducer,
    modeToolDraft: modeToolDraftReducer,
    directiosApiRoutePoint: directiosApiRoutePointReducer,
    directiosApiRoutePointRaw: directiosApiRoutePointRawReducer
  }
});

export default store;
